"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const cache = endpoints_1.endpoints.cache;
const redisCache = endpoints_1.endpoints.redisCache;
const cacheController = (service) => ({
    readAllCache: () => {
        return service.get(cache, service.addAccessTokenToHeaders);
    },
    delCache: (cacheKey) => {
        const url = `${cache}/${encodeURIComponent(cacheKey)}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    },
    delAllCache: () => {
        return service.delete(cache, service.addAccessTokenToHeaders);
    },
    //
    readAllRedisCache: () => {
        return service.get(redisCache, service.addAccessTokenToHeaders);
    },
    delRedisCache: (cacheKey) => {
        const url = `${redisCache}/${cacheKey}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    },
    delAllRedisCache: () => {
        return service.delete(redisCache, service.addAccessTokenToHeaders);
    },
});
exports.cacheController = cacheController;
